<template>
    <navBar title="Ares - Marketing" :home="true" type="marketing" />
</template>

<script>
    import navBar from '@/components/ui/navbars/navbar.vue';

    export default {
        components: {
            navBar,
        },
    }

</script>